import type { OptionType } from '@innovamat/glimmer-components';

const standards: OptionType[] = [
  { value: 'BUBBLE_TREE', label: 'Bubble Tree' },
  { value: 'COMMON_CORE', label: 'Common Core' },
  { value: 'NEW_JERSEY', label: 'New Jersey' },
  { value: 'WEST_VIRGINIA', label: 'West Virginia' },
  { value: 'PENNSYLVANIA', label: 'Pennsylvania' },
  { value: 'CALIFORNIA', label: 'California' },
  { value: 'ILLINOIS', label: 'Illinois' },
  { value: 'QA_STANDARD', label: 'QA_STANDARD' },
];

const isCommonCoreStandard = (standard: string): boolean =>
  standard === 'COMMON_CORE';

const isNewJerseyStandard = (standard: string): boolean =>
  standard === 'NEW_JERSEY';

const isPennsylvaniaStandard = (standard: string): boolean =>
  standard === 'PENNSYLVANIA';

const isWestVirginiaStandard = (standard: string): boolean =>
  standard === 'WEST_VIRGINIA';

const isValidatedUSStandard = (standard: string): boolean =>
  isCommonCoreStandard(standard) ||
  isNewJerseyStandard(standard) ||
  isPennsylvaniaStandard(standard) ||
  isWestVirginiaStandard(standard);

export { isValidatedUSStandard, standards };
